import styled, { keyframes } from 'styled-components';
import { DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';

const reveal = keyframes`
  from    {opacity: 0;}
  to      {opacity: 1;}
`;

export const Section = styled(Grid)`
  animation: ${reveal} 0.8s linear forwards;
  opacity: 0;
  padding: ${({ theme }) => `0 ${theme.x3spacePx}px`};
  margin: ${({ theme }) => theme.x10spacePx}px 0;
  ${media.mdDown`
    margin-top: ${({ theme }) => theme.x5spacePx}px 0;
  `}
`;

export const TextWrapper = styled('div')`
  > * {
    margin-bottom: ${({ theme }) => theme.x1spacePx}px;
  }
`;
